import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const ContactSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        {
            title: 'contact.settings.default_entity_type_title',
            scope: 'division',
            explanationText: 'contact.settings.default_entity_type_explanation',
            fields: [
                {
                    type: 'dropdown',
                    name: 'contact_default_entity_type',
                    allowNoneOption: false,
                    showSearch: false,
                    defaultValue: { value: 'organization' },
                    hardcodedOptions: [
                        { value: 'organization', name: 'contact.settings.organizations_option' },
                        { value: 'person', name: 'contact.settings.persons_option' },
                    ]
                }
            ]
        },
        {
            title: 'contact.settings.numbering_scheme_title',
            explanationText: 'contact.settings.numbering_scheme_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'settings.general.number_sequence_title',
                    name: 'contact_numbering_scheme',
                    placeholder: '',
                    group: 'field-row',
                    shouldAutoFocus: false
                },
                {
                    type: 'number',
                    label: 'settings.general.next_number_label',
                    name: 'contact_current_number',
                    group: 'field-row'
                }
            ]
        },
    ];

    return (
        <SettingsContainer settings={settings} />
    );
};

export default ContactSettings;
